import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '@/environments/environment';
import {CardDestroyResult, CardStats} from '@/app/core/models/inventory.model';
import {FavoriteCard, SetFavoriteCardsRequest} from '@/app/core/models/collection/favorite-card.model';

@Injectable({
	providedIn: 'root'
})
export class CardService {

	private readonly SERVICE_URI = `${environment.backendUrl}/cards`;

	private readonly http: HttpClient = inject(HttpClient);

	getCardStats(): Observable<CardStats> {
		return this.http.get<CardStats>(`${this.SERVICE_URI}/stats`);
	}

	/** PepsCoins rendus par la destruction d'un exemplaire, par rareté (piloté depuis le back-office). */
	getDestroyRewards(): Observable<Partial<Record<string, number>>> {
		return this.http.get<Partial<Record<string, number>>>(`${this.SERVICE_URI}/destroy-rewards`);
	}

	getFavorites(): Observable<FavoriteCard[]> {
		return this.http.get<FavoriteCard[]>(`${this.SERVICE_URI}/favorites`);
	}

	setFavorites(userCardIds: string[]): Observable<FavoriteCard[]> {
		const body: SetFavoriteCardsRequest = {userCardIds};
		return this.http.put<FavoriteCard[]>(`${this.SERVICE_URI}/favorites`, body);
	}

	/**
	 * Détruit l'exemplaire (ligne user_cards) contre des PepsCoins.
	 * Impossible pour une carte COLLECTOR — à vérifier côté appelant avant d'afficher l'action.
	 */
	destroyCard(userCardId: string): Observable<CardDestroyResult> {
		return this.http.post<CardDestroyResult>(`${this.SERVICE_URI}/user-cards/${userCardId}/destroy`, {});
	}
}
